import { render, staticRenderFns } from "./ModalCreateTemplateConfig.vue?vue&type=template&id=ce470bce&"
import script from "./ModalCreateTemplateConfig.vue?vue&type=script&lang=js&"
export * from "./ModalCreateTemplateConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports